module.exports = __webpack_public_path__ + "static/media/close-black.82107a83.svg";